export default {"src":"/_next/static/media/chevron_dropdown.65597ab8.svg","height":5,"width":10,"blurWidth":0,"blurHeight":0};